// The current calendar year to date. At tenant scale (Amazon ~134K streams)
// the WasteLineUnified join dominates stream query cost — partitioning by
// shippedDate prunes monthly partitions outside this window, so a bounded
// range is the difference between a few seconds and ~11s.
export const defaultShipDateStart = new Date(new Date().getFullYear(), 0, 1)
  .toISOString()
  .slice(0, 10);
export const defaultShipDateEnd = new Date().toISOString().slice(0, 10);
